module.exports = __webpack_public_path__ + "img/puzzle_10.7f1671da.png";